import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['seat', 'count', 'submit']

  toggleSeat() {
    this.updateCount()
  }

  updateCount() {
    const checked = this.element.querySelectorAll('input[name="seat_ids[]"]:checked')
    const count = checked.length
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${count} seat${count !== 1 ? 's' : ''} selected`
    }
  }
}
